import { render, staticRenderFns } from "./feature-type-group.vue?vue&type=template&id=128a4052&"
import script from "./feature-type-group.vue?vue&type=script&lang=js&"
export * from "./feature-type-group.vue?vue&type=script&lang=js&"
import style0 from "./feature-type-group.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports